import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Params } from '@angular/router';
import { RouterReducerState, getRouterSelectors } from '@ngrx/router-store';
import { mergeRouteParams } from '../_utils/router.utils';

export const selectRouter = createFeatureSelector<RouterReducerState>('router');

export const selectMergedRouteParams = createSelector(selectRouter, router =>
  router ? mergeRouteParams(router.state.root, r => r.params) : {},
);

export const {
  selectQueryParams, // select the current route query params
  selectQueryParam,
  selectRouteParams, // select the current route params
  selectRouteData, // select the current route data
  selectUrl, // select the current url
} = getRouterSelectors(selectRouter);

export const selectRouteTimestamp = createSelector(selectQueryParams, (params: Params | undefined) =>
  params && 'timestamp' in params ? (params.timestamp as number) : null,
);

export const selectReturnUrl = createSelector(selectUrl, selectQueryParam('returnUrl'),
  (state, returnUrl): string | null => {
    const normalized = Array.isArray(returnUrl) ? returnUrl[0] : returnUrl;
    const url = normalized || state;
    return url !== '/login' ? url : null;
  }
);
